namespace KWS.controllers.categoryBrowsing {
    function test() {

}

    export function init() {
        test();
    }
}

KWS.controllers.categoryBrowsing.init();